export default "__VITE_ASSET__CnlF9UXN__"